import { z } from "zod";

export const adpRunCreateConnectionBodySchema = z.object({
    workspaceId: z.string().uuid(),
    authCode: z.string().min(1),
    defaultEntityId: z.number().int().positive().optional(),
});

export type AdpRunCreateConnectionBody = z.infer<
    typeof adpRunCreateConnectionBodySchema
>;
